var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count_box"},[_c('i',{staticClass:"iconfont icon-jinggao"}),(_vm.step === 1)?_c('span',[_vm._v("验证通过后，请在5分钟内完成新手机绑定")]):(_vm.step === 2)?_c('span',[_vm._v(_vm._s(_vm.rs)+"s 后验证失效，需重新验证")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }